// Faculty roster for the Converged Security Institute.
// To add a guest or adjunct instructor, append a new object to the `FACULTY` list.
// Place the headshot in /app/frontend/public/instructors/<slug>.jpg and reference it
// as `image: "/instructors/<slug>.jpg"`.
//
// Each entry supports the same bio layout as Prof. Dr. Vladimir Bunic.
// Required fields: slug, name, title, type ("chief" | "guest" | "adjunct"), image, blurb.
// Optional fields: bio_paragraphs (string[]), qualifications (string[]), linkedin, email,
// positions ({title, sub, icon}[]), expertise (string[]), achievements ({year, title, desc}[]).

export const FACULTY = [
  {
    slug: "vladimir-bunic",
    name: "Prof. Dr. Vladimir Bunic",
    title: "Chief Instructor & Managing Director",
    type: "chief",
    image: "/instructors/vladimir-bunic.jpg",
    tagline: "Cybersecurity & Digital Resilience Leader · Converged Security Strategist · Distinguished Professor · Industry Advisor",
    blurb:
      "Over two decades at the intersection of cyber, physical and digital security - designing integrated security architectures that strengthen organisational resilience and enable confident executive decision-making.",
    linkedin: "https://www.linkedin.com/in/vladimir-bunic/",
    email: "info@convergedsecurity.es",
    qualifications: [
      "D.Sc. in Cyber-Physical Security",
      "PhD in Cybersecurity",
      "DBA in General Management",
      "PG studies: Digital Transformation, International Law, Project Management",
    ],
    bio_paragraphs: [
      "With over two decades at the intersection of cyber, physical and digital security, Prof. Dr. Vladimir Bunic specialises in designing integrated security architectures that strengthen organisational resilience and enable confident decision-making in complex environments. His work blends deep technical expertise with strategic clarity, ensuring organisations stay ahead of evolving threats.",
      "He holds a Doctor of Science (D.Sc) in Cyber-Physical Security, a PhD in Cybersecurity and a DBA in General Management, supported by postgraduate studies in Digital Transformation, International Law and Project Management. This multidisciplinary foundation allows him to bridge executive strategy with advanced security engineering.",
      "As a QAHE Distinguished Professor in IT & Cyber Security and a Certified Lecturer in Cybersecurity, he is committed to making sophisticated security concepts accessible for executives, practitioners and future leaders. His dedication to education has been recognised through the Excellence in Education Award 2026-2027.",
      "His industry contributions have also earned global recognition, including the Cybersecurity Excellence Award - Continuous Improvement & Optimization Expert of the Year (2026 Winner), highlighting his impact on advancing security standards and operational resilience.",
      "Across consulting, academia and leadership roles, Prof. Dr. Bunic collaborates with multidisciplinary teams to identify vulnerabilities, enhance cyber-physical systems and align security initiatives with business value. He remains actively engaged in global forums and workshops, advocating for stronger security cultures and driving forward the evolution of digital resilience.",
    ],
    positions: [
      { title: "Chief Instructor & Managing Director, Converged Security Institute (CSI)", sub: "Converged Security & Digital Transformation Strategist", icon: "briefcase" },
      { title: "Distinguished Professor in IT & Cyber Security", sub: "QAHE & Pebble Hills University Distinguished Professorship (May 2026) · Certified Lecturer in Cybersecurity", icon: "graduation" },
      { title: "Dean of Cybersecurity Programme", sub: "Business Technology Academy, Ireland", icon: "book" },
      { title: "Cyber-Physical Systems Security Expert", sub: "Nestlé - global enterprise cyber-physical security", icon: "sparkles" },
      { title: "Professor, IT OTHM Programmes", sub: "C3S Business School (until June 2026)", icon: "graduation" },
      { title: "GCSB leadership: President & Chair; Managing Director / CEO", sub: "Global Converged Security Board (GCSB), the independent accrediting body - separate from his CSI role", icon: "book" },
    ],
    expertise: [
      "Converged Security Architecture",
      "Cyber-Physical Security",
      "Cybersecurity & Digital Resilience",
      "Governance, Risk & Compliance",
      "Digital Transformation Enablement",
      "Integrated Physical & Cyber Security",
      "Security Technology Solutions",
      "International Law & Security Governance",
      "Project & Programme Leadership",
      "Threat Intelligence & Incident Management",
      "Security Culture & Education",
      "Strategic Risk Management",
    ],
    achievements: [
      { year: "2026", title: "Distinguished Professor in IT & Cyber Security", desc: "Recognised by QAHE with a Distinguished Professorship Award, reflecting academic leadership and contribution to IT and cyber security education." },
      { year: "2026", title: "Winner - Cybersecurity Excellence Awards", desc: "2026 winner in the Cybersecurity Excellence Awards - Continuous Improvement & Optimization Expert of the Year." },
      { year: "2025 / 2026", title: "Excellence in Education Award", desc: "Recognised with the Excellence in Education Award 2026-2027 for dedication to making sophisticated security concepts accessible to executives, practitioners and future leaders." },
      { year: "2025", title: "Global Recognition & Industry Leadership", desc: "Recognised for strategic leadership, industry transformation, research excellence and education leadership in converged security at global forums and workshops." },
      { year: "Ongoing", title: "Converged Security Thought Leadership", desc: "Author of publications on enterprise converged security systems, EU legislative frameworks, governance challenges and security for manufacturing environments." },
    ],
  },
  // Example guest / adjunct entry (uncomment and complete when ready):
  // {
  //   slug: "jane-smith",
  //   name: "Jane Smith, PhD",
  //   title: "Guest Lecturer - OT & Industrial Security",
  //   type: "guest",
  //   image: "/instructors/jane-smith.jpg",
  //   tagline: "OT security · Industrial resilience · NIS2 implementation",
  //   blurb: "Lead OT security advisor for critical infrastructure operators across Europe.",
  //   qualifications: ["PhD in Cyber-Physical Systems", "GICSP · ISA/IEC 62443"],
  //   expertise: ["Operational Technology", "NIS2 Compliance", "Industrial Control Systems"],
  // },
];

export const FACULTY_TYPES = {
  chief: { label: "Chief Instructor", order: 0 },
  guest: { label: "Guest Lecturer", order: 1 },
  adjunct: { label: "Adjunct Faculty", order: 2 },
};
